<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit User') : $t('New User')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.name"
              :label="$t('user.name')"
              autocomplete="new-password"
              v-validate="'required'"
              required
              data-vv-name="name"
              :error-messages="errors.collect('name')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.email"
              label="Email"
              autocomplete="new-password"
              v-validate=""
              data-vv-name="email"
              :disabled="!$auth.check('user.create')"
              :error-messages="errors.collect('email')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.password"
              :label="$t('user.password')"
              type="password"
              autocomplete="new-password"
              data-vv-name="password"
              :error-messages="errors.collect('password')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.password_confirmation"
              :label="$t('user.password_confirm')"
              type="password"
              autocomplete="new-password"
              data-vv-name="password_confirmation"
              :error-messages="errors.collect('password_confirmation')"
            ></v-text-field>
            <v-select
              v-if="$auth.check('user.create')"
              v-model="formValues.roles"
              multiple
              :items="roles"
              label="Berechtigungen"
              item-text="name"
              item-value="name"
            ></v-select>
            <v-card-actions class="pl-0">
              <v-btn
                v-if="$auth.check('user.create')"
                class="mr-4"
                @click="$router.push({ name: 'user.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveUser">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  fetchRoles,
  saveUser,
  fetchUser,
  fetchCompanies
} from "../shared/services";
export default {
  name: "app-user-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: "",
        email: "",
        password: ""
      },
      roles: [],
      companies: [],
      loading: true
    };
  },
  mounted() {
    this.loading = true;
    this.getData().then(() => {
      if (this.$route.params.id) {
        fetchUser(this.$route.params.id).then(res => {
          this.formValues = res.data;
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    });
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    getData() {
      return Promise.all([this.getRoles()]);
    },
    async getRoles() {
      if (this.$auth.check("user.create")) {
        this.roles = (await fetchRoles(this.options)).data;
      }
    },
    async saveUser() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveUser(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        if (resp.data && resp.data.password) {
          await this.$root.$confirm(
            this.$t("User created"),
            this.$t("Password for new user: ") + resp.data.password
          );
        }

        this.$root.$notification(resp.message, { type: "success" });
        if (this.$auth.check("user.create")) {
          this.$router.push({ name: "user.index" });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
